export const enum Roles {
  SUPERUSER = 'ROLE_SUPERUSER',
}
